import tailwindConfig from '@/tailwind.config';

// Define a type for colors
type MyColors = {
  green: string;
  red: string;
  redDark: string;
  yellow: string;
  orangeLight: string;
  orangDark: string;
  dark: string;
  gray: string;
  gray400: string;
  gray300: string;
  primaryLight: string;
  secondaryDark: string;
  secondary: string;
  primaryDark: string;
  primary: string;
  primary200: string;
  orange: string;
  white: string;
 
};

// Extract colors
export const colors: MyColors =
  (tailwindConfig.theme?.extend?.colors as MyColors) || {};
